function a(r) {
  return Array.isArray(r);
}
function i(r, ...o) {
  return [...r].sort((e, s) => {
    for (const t of o) {
      const n = t(e), c = t(s);
      if (n !== c)
        return n ? -1 : 1;
    }
    return 0;
  });
}
export {
  a as isStringArray,
  i as sortBy
};
